/**
 * Guidance Page - Show Photo/Video Requirements Based on URL Parameter
 */

export function GuidancePage() {
  const urlParams = new URLSearchParams(window.location.search);
  const checklist = urlParams.get('checklist');

  return (
    <div className="container">
      <div className="form-section">
        {checklist === 'photo' ? (
          <>
            <h2>📸 Photo Requirements</h2>
            <hr className="section-divider" />

            <h3>General Property Condition:</h3>
            <ul>
              <li>
                Street view of the property front (1 photo)
              </li>
              <li>Rear of property (up to 3 photos)</li>
              <li>Side(s) of property (2 photos)</li>
              <li>Under elevated deck, if applicable (1 photo)</li>
              <li>Garage interior (1 photo)</li>
              <li>Lockbox with accompanying keys (1 photo)</li>
              <li>Running water (faucet turned on) (1 photo)</li>
              <li>Sprinkler system observed (visual only - do NOT operate)</li>
            </ul>

            <h3>Interior Spaces:</h3>
            <ul>
              <li>Living area(s) (up to 10 photos)<br/>Living areas include kitchen, living rooms, loft etc.</li>
              <li>Bedrooms (up to 10 photos)</li>
              <li>Bathrooms (up to 10 photos)</li>
              <li>Gas kitchen range turned on (if applicable) (1 photo)</li>
            </ul>

            <h3>Mechanical & Utility:</h3>
            <ul>
              <li>HVAC unit with date of manufacture (1 photo)</li>
              <li> Water heater with date of manufacture (1 photo)</li>
            </ul>

            <h3>Additional Features:</h3>
            <ul>
              <li>Shed(s) or casita (1 photo per, if applicable)</li>
              <li>Unique home features that may add value (up to 5 photos)</li>
              <li>Property damage (up to 5 photos with description)</li>
            </ul>
          </>
        ) : (
          <>
            <h2>🎥 Video Requirements</h2>
            <hr className="section-divider" />

            <h3>Before You Start:</h3>
            <ul>
              <li>Walk the property to understand what call outs you want to make</li>
              <li>Record in <strong>landscape (horizontal) mode</strong></li>
              <li><strong>Turn on all lights</strong> and <strong>open all interior doors</strong> before filming</li>
              <li><strong>Clean your lenses</strong> and ensure image is not blurry</li>
            </ul>

            <h3>Exterior Walkthrough</h3>
            <ul>
              <li>Start at <strong>sidewalk level</strong> state the <strong>property address aloud</strong></li>
              <li>Full walkaround of the home (front, sides, rear)</li>
              <li>Show roofline, gutters, drainage, soffits, fascia, and foundation</li>
              <li>Point out and <strong>hover on exterior damage</strong> (e.g., warped siding, cracks, worn decks)</li>
            </ul>
            
            <h3>Interior Walkthrough</h3>
            <ul>
              <li>Walk room-by-room in a clear, logical order</li>
              <li>Capture each room <strong>corner-to-corner</strong> to show full layout</li>
              <li>Call out and show <strong>flooring, counters, fixtures, ceiling fans, lighting</strong></li>
              <li>Focus and pause on <strong>any areas needing repair</strong> (~5 seconds)</li>
              <li>Open cabinets, turn on faucets, while water is running to expose possible leaks</li>
              <li>Flush tollets to show working order</li>
              <li>Please video the thermostat to show current temperature and comment on the comfortability of the home</li>
            </ul>

            <h3>Audio & Commentary</h3>
            <ul>
              <li>Speak clearly and steadily</li>
              <li>Call out both damage and home features<br/>Common callouts are cracks, scuffs, texture mismatches, roof damage, mismatching doorknobs or fixtures, non-working doors/locks, mismatched flooring, cracked flooring, cracked flooring etc. Think, <i>what would you want to know about a home before buying it?</i></li>
              <li>Mention strong odors if observed (smoke, mildew, pets, etc.)</li>
              <li>Avoid fast movements, shaky camera work, or rushing past damage</li>
            </ul>
          </>
        )}
        
      </div>
    </div>
  );
}
